// extracted by mini-css-extract-plugin
export default {"new_plugin":"NewAsset_new_plugin__+Rb2f","heading":"NewAsset_heading__8Liau","back_button":"NewAsset_back_button__W12ST"};